// Порядок = порядок в переключателе языков: казахский, русский, английский.
export const supportedLocales = [
  { code: 'kz-KZ', label: 'ҚАЗ' },
  { code: 'ru-RU', label: 'РУС' },
  { code: 'en-US', label: 'ENG' },
] as const

export type LocaleCode = (typeof supportedLocales)[number]['code']
